import { Slot as SlotPrimitive } from 'radix-ui';

import { POSTHOG_SENSITIVE_MASK_ID } from '@/posthog';

interface SensitiveFieldProps extends React.HTMLAttributes<HTMLElement> {
  asChild?: boolean;
}

/**
 * Wraps sensitive data (PII, PHI, etc.) to mask it in PostHog session recordings.
 * Use this component for any field that contains sensitive information like
 * phone numbers, addresses, member IDs, names, etc.
 *
 * @example
 * // Renders a span wrapper
 * <SensitiveField>Phone number</SensitiveField>
 *
 * @example
 * // Merges with the child element
 * <SensitiveField asChild>
 *   <p className="text-sm">Phone number</p>
 * </SensitiveField>
 */
export function SensitiveField({ asChild = false, children, ...props }: SensitiveFieldProps) {
  const Comp = asChild ? SlotPrimitive.Slot : 'span';

  return (
    <Comp id={POSTHOG_SENSITIVE_MASK_ID} {...props}>
      {children}
    </Comp>
  );
}
